<div class="w-full">
    <!-- <div class="rounded-t hidden w-full overflow-x-auto lg:block shadow-lg rounded bg-white"> -->
    @let loadingAwards = (loading$ | async) ?? false;
    <div class="w-full flex flex-col gap-4">

        @for (item of awards; track item.id) {
        <div class="bg-white shadow-lg rounded w-full px-4 py-3">
            <div class="cursor-default flex flex-col gap-1">
                <div class="flex flex-row items-start justify-between gap-4 w-full">
                    <a class="flex flex-col justify-start">
                        <div class="flex flex-row items-center gap-2">
                            <p class="text-primary-300 text-xs whitespace-nowrap">
                                {{ item.created.toDate() | moment: 'Do MMM YYYY' }}
                            </p>
                            @if ((fetchAllGroups() || showGroupName()) && item.groupId && groupNames[item.groupId]) {
                            <span class="text-xs text-blueGray-600 bg-blueGray-100 font-medium px-2 py-0.5 rounded-full">
                                {{ groupNames[item.groupId] }}
                            </span>
                            }
                        </div>
                        <div class="flex flex-row flex-nowrap gap-2 mt-1">
                            <a [href]="item.url || null"
                                [class]="item.url ? 'text-blue-500 hover:underline' : 'text-gray-400 cursor-not-allowed'"
                                [attr.target]="item.url ? '_blank' : null"
                                [attr.rel]="item.url ? 'noopener noreferrer' : null"><i
                                    class="far fa-file-pdf text-lg inline"></i>
                                <p class="font-semibold text-primary-500 inline ml-1">
                                    {{ item.awardName }}
                                </p>
                            </a>
                        </div>
                    </a>
                    <div class="flex flex-row gap-2 whitespace-nowrap">
                        @let roles = (myRoles$ | async);
                        @if(canDelete(item, roles)) {
                        <app-btn-fab (click)="onDelete(item)" icon="fa fa-trash-can"
                            textColor="text-red-500 disabled:text-gray-200" tooltip="Delete"></app-btn-fab>
                        }
                    </div>
                </div>
            </div>
        </div>
        } @empty {
        @if(!loadingAwards) {
        <div class="px-6 py-4 text-center font-semibold border-0 whitespace-nowrap text-blueGray-500">
            No Certificates Found
        </div>
        }
        }
        @if(loadingAwards) {
        <div class="bg-white shadow-lg rounded p-4 mt-1 w-full mx-auto">
            <div class="animate-pulse flex space-x-4">
                <div class="flex-1 space-y-2">
                    <div class="h-3 w-1/4 bg-slate-200 rounded"></div>
                    <div class="h-4 w-2/3 bg-slate-200 rounded"></div>
                    <div class="space-y-2">
                        <div class="grid grid-cols-3 gap-4 mb-2">
                            <div class="h-4 bg-slate-200 rounded col-span-2"></div>
                            <div class="h-4 bg-slate-200 rounded col-span-1"></div>
                        </div>
                        <div class="flex flex-row gap-2 justify-start items-center">
                            <div class="h-6 w-6 bg-slate-200 rounded-full"></div>
                            <div class="h-4 w-1/4 bg-slate-200 rounded"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        }
    </div>

    @let hasMore = (hasMore$ | async) ?? false;
    @if(!loadingAwards && (awards?.length ?? 0) > 0 && hasMore) {
    <div class="flex flex-row w-full justify-center px-4 mt-3">
        <app-btn-more (click)="addMore()" [isDisabled]="loadingAwards"></app-btn-more>
    </div>
    }
</div>